import { tryRequest } from 'shared/utilities';
import axios from 'axios';

const version = '/api/v1';

export default {
  getProjectList(orgId) {
    return axios({
      method: 'get',
      url: `${version}/project?orgId=${orgId}`,
    });
  },
  postProject(payload) {
    const { projectName, orgId } = payload;
    return axios({
      method: 'post',
      url: `${version}/project`,
      data: {
        name: projectName,
        orgId,
      },
    });
  },
  update(projectId, payload) {
    return tryRequest(axios.patch(`${version}/project/${projectId}`, payload));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/projects/api.js